module.exports = __webpack_public_path__ + "img/20190819155753336.54f4f49b.png";